<script setup lang="ts">
import type { PropType } from 'vue'
import type BackgroundBanner from '~/models/BackgroundBanner'
import { useMatomoViewportTrack, useMatomoClickTrack } from '~/composables/useMatomo'

const props = defineProps({
    banner: {
        type: Object as PropType<BackgroundBanner>,
        required: true,
    },
})

onMounted(() => {
    const page = document.getElementById('pageWrap')
    if (page) {
        if (props.banner.targetUrl !== '') {
            page.insertAdjacentHTML(
                'afterbegin',
                `<div class="d-flex justify-content-center overflow-hidden">
                    <a href="${props.banner.targetUrl}" class="page-banner-link" style="left: 0"></a>
                    <a href="${props.banner.targetUrl}" class="page-banner-link" style="right: 0"></a>
                    <div class="page-banner" style="background-image: url('${props.banner.imageUrl}')" id="landing-page-banner"></div>
                 </div>`
            )
        } else {
            page.insertAdjacentHTML(
                'afterbegin',
                `<div class="d-flex justify-content-center overflow-hidden">
                    <div class="page-banner" style="background-image: url('${props.banner.imageUrl}')" id="landing-page-banner"></div>
                 </div>`
            )
        }

        const banner: HTMLElement | null = document.getElementById('landing-page-banner')
        if (banner) {
            useMatomoViewportTrack(banner, {
                category: 'Landing page banner',
                action: 'view',
                name: props.banner.title,
                value: props.banner.id,
            })

            useMatomoClickTrack(banner, {
                category: 'Landing page banner',
                action: 'click',
                name: props.banner.title,
                value: props.banner.id,
            })
        }
    }
})

onUnmounted(() => {
    const banner = document.getElementsByClassName('page-banner')[0]
    if (banner) {
        banner.parentElement?.remove()
    }
})
</script>

<style>
.page-banner {
    width: 2173px;
    height: 100vh;
    position: absolute;
    z-index: -10;
    background-repeat: no-repeat;
    display: none;

    @include screen-md {
        display: block;
    }
}

.page-banner-link {
    position: absolute;
    width: calc(50vw - 630px);
    height: 100vh;
}
</style>
